import { SvgComponentProps } from "@/src/types/SVGPropType";
import * as React from "react";
const Pro6SVG: React.FC<SvgComponentProps> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={17}
    height={17}
    fill="none"
    {...props}
  >
    <path
      fill="#EDEDED"
      fillRule="evenodd"
      d="M8.328.81c-4.422 0-8 3.617-8 8.031 0 4.38 3.55 7.97 7.939 7.97a7.938 7.938 0 0 0 4.207-1.207l.252-.157-.795-1.272-.252.157a6.438 6.438 0 0 1-3.412.978c-3.552 0-6.439-2.909-6.439-6.469 0-3.594 2.914-6.53 6.5-6.53a6.5 6.5 0 0 1 6.5 6.5v.607c0 .769-.623 1.393-1.393 1.393-.887 0-1.607-.72-1.607-1.608V5.311h-1.5v.627a3.5 3.5 0 1 0 .647 5.163 3.102 3.102 0 0 0 2.46 1.21 2.893 2.893 0 0 0 2.893-2.893V8.81a8 8 0 0 0-8-8Zm2 8a2 2 0 1 0-4 0 2 2 0 0 0 4 0Z"
      clipRule="evenodd"
    />
  </svg>
);
export default Pro6SVG;
